import { useEffect, useRef } from 'react';
import Artplayer from 'artplayer';

interface ArtVideoPlayerProps {
  title: string;
  url: string;
  poster?: string;
  onEnded: () => void;
  onError: () => void;
  onReady?: () => void;
}

/**
 * ArtPlayer视频播放器组件
 *
 * @author xiaojingge
 */
export function ArtVideoPlayer({ title, url, poster, onEnded, onError, onReady }: ArtVideoPlayerProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) {
      return undefined;
    }

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const player = new Artplayer({
      container: containerRef.current,
      url,
      poster,
      autoplay: true,
      autoSize: false,
      autoMini: false,
      loop: false,
      mutex: true,
      volume: 0.8,
      theme: '#FFD93D',
      setting: !isMobile,
      playbackRate: !isMobile,
      aspectRatio: !isMobile,
      fullscreen: true,
      fullscreenWeb: !isMobile,
      pip: !isMobile,
      miniProgressBar: true,
      lock: true,
      moreVideoAttr: {
        playsInline: true,
        crossOrigin: 'anonymous',
      },
    });

    player.on('video:ended', onEnded);
    player.on('video:error', onError);
    if (onReady) {
      player.on('video:canplay', onReady);
      player.on('video:playing', onReady);
    }

    return () => {
      player.destroy(false);
    };
  }, [title, url, poster, onEnded, onError, onReady]);

  return <div className="art-player-shell" ref={containerRef} />;
}
